module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-1100.3ccf5066.svg";